import domReady from './inc/dom-ready.js';
import { boilerplateNavMain, stickyHeader } from './inc/nav-main.js';
import elmntIO from './inc/elmnt-io.js';

import { accordion } from './inc/accordion.js';


domReady( function () {
    //do something after DOM loads.
    console.log('app.js', 'hello');

    boilerplateNavMain();
    stickyHeader(200);

    const $elmntIos = document.querySelectorAll('[data-io]');
    $elmntIos.forEach($el => elmntIO($el));
    

    if ( document.querySelector('.accordion') ) {
        accordion();
    }
} );